import React from 'react';
import DataGridD from '../components/resuableComponents/DataGridD';

const BookingHistory = () => {
	return (
		<div>
			<DataGridD />
		</div>
	);
};

export default BookingHistory;
